import React from 'react';
interface SkeletonTableProps {
  rows?: number;
  columns?: number;
  hasHeader?: boolean;
  className?: string;
}
const SkeletonTable: React.FC<SkeletonTableProps> = ({
  rows = 5,
  columns = 5,
  hasHeader = true,
  className = ''
}) => {
  return <div className={`rounded-lg border border-gray-200 bg-white shadow-sm animate-pulse ${className}`} data-id="element-690">
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-691">
        <div className="h-6 bg-gray-200 rounded w-1/4" data-id="element-692"></div>
      </div>
      <div className="p-6" data-id="element-693">
        <div className="overflow-x-auto" data-id="element-694">
          <table className="w-full" data-id="element-695">
            {hasHeader && <thead data-id="element-696">
                <tr className="bg-gray-50" data-id="element-697">
                  {Array(columns).fill(0).map((_, index) => <th key={`header-${index}`} className="px-6 py-3" data-id="element-698">
                        <div className="h-4 bg-gray-200 rounded w-full" data-id="element-699"></div>
                      </th>)}
                </tr>
              </thead>}
            <tbody data-id="element-700">
              {Array(rows).fill(0).map((_, rowIndex) => <tr key={`row-${rowIndex}`} className="border-t border-gray-200" data-id="element-701">
                    {Array(columns).fill(0).map((_, colIndex) => <td key={`cell-${rowIndex}-${colIndex}`} className="px-6 py-4" data-id="element-702">
                          <div className="h-4 bg-gray-200 rounded w-full" data-id="element-703"></div>
                        </td>)}
                  </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};
export default SkeletonTable;